var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liveSchedule"},[_c('div',{staticClass:"title"},[_vm._v("配信予定管理")]),_c('section',{staticClass:"section"},[_c('IvsInformation')],1),_c('section',{staticClass:"section submit-button has-text-centered"},[_c('b-button',{staticClass:"button submit",on:{"click":function($event){return _vm.registraion()}}},[_vm._v("新しい配信予定を登録")])],1),_c('section',{staticClass:"section list"},[_c('div',{staticClass:"container"},[_vm._l((_vm.recentLives),function(live){return _c('LiveListedRow',{key:live.id,attrs:{"tileData":{
          liveId: live.id,
          imageSrc: live.thumbnailURL,
          nickname: live.performerNickname,
          startAt: live.startAt,
          title: live.title,
          type: 'recent',
          disabled: false
        }},on:{"update":_vm.update,"action":_vm.moveConsole}})}),_vm._l((_vm.upComingLives),function(live){return _c('LiveListedRow',{key:live.id,attrs:{"tileData":{
          liveId: live.id,
          imageSrc: live.thumbnailURL,
          nickname: live.performerNickname,
          startAt: live.startAt,
          title: live.title,
          type: 'upComing',
          disabled: _vm.recentLives.length > 0
        }},on:{"update":_vm.update,"action":_vm.startStreaming}})})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }